<template>
  <v-navigation-drawer style="z-index: 99;" app mobile-breakpoint="800" v-model="drawer" class="app-drawer">
    <v-toolbar-title class="app-title ml-0 pl-3" @click="gotoHome()">
      <div>
        <img
          class="top-logo"
          :src="computeRCIcon"
          width="70%"
          alt="RC"
          @click="gotoHome()"
        />
      </div>
      <div>
        <img
          class="top-logo"
          :src="computeLogoIcon"
          alt="RC IREG"
          @click="gotoHome()"
        />
      </div>
      <div class="menu-top-text">
        <p class="hidden-sm-and-down">
          {{ $t('Įgaliojimų registravimo ir duomenų teikimo programa') }}
        </p>
      </div>
    </v-toolbar-title>
    <div class="app-drawer__inner">
      <template v-for="(group, groupIndex) in filteredMenuList">
        <v-list
          v-if="group.children"
          dense
          :disabled="group.disabled"
          :key="`${groupIndex}_group`"
          v-show="hasRoleGroup(group)"
        >
          <v-list-group
            :value="`group-${groupIndex}`"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title :class="group.class">
                  {{ $t(group.title) }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(item, index) in group.children"
              :key="`item${groupIndex}-${index}`"
              active-class
              :disabled="item.disabled"
              :class="getClass(item)"
              active
              @click="goTo(item)"
              v-show="hasRole(item)"
            >
              <v-list-item-title v-text="$t(item.title)"></v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list>
         <v-list
          v-if="!group.children"
          dense
          :disabled="group.disabled"
          :key="`${groupIndex}_item`"
          v-show="hasRoleGroup(group)"
        >
          <v-list-item
              active-class
              :class="getClass(group)"
              :style="`color: #198677 !important;`"
              active
              @click="goTo(group)"
              v-show="hasRole(group)"
            >
              <v-list-item-title v-text="$t(group.title)"></v-list-item-title>
            </v-list-item>
        </v-list>
      </template>
    </div>
  </v-navigation-drawer>
</template>
<script>
import Roles from '@/components/constants/roles'

export default {
  name: 'AppDrawer',
  data() {
    return {
      drawer: true,
    }
  },
  computed: {
    computeRCIcon() {
      return '/static/rclogo.png'
    },
    computeLogoIcon() {
      return '/static/ireg-icon.png'
    },
    menuList() {
      return [
                {
          name: 'messagesTab',
          title: 'RENGIAMI / PATEIKTI PRANEŠIMAI',
          class: 'menu-list-title',
          children: [
            {
              name: 'adminMessageNew',
              title: 'Naujas pranešimas',
              routeRole: [Roles.NOTARAS, Roles.KONSULAS, Roles.TEISMAS, Roles.NOT_PAD, Roles.KAL_VAD, Roles.NOT_PAD2, Roles.IR_REGISTRATORIUS],
            },
            {
              name: 'adminMessagesPreparedSent',
              title: 'Rengiami ir pateikti pranešimai',
              routeRole: [Roles.NOTARAS, Roles.KONSULAS, Roles.TEISMAS, Roles.NOT_PAD, Roles.KAL_VAD, Roles.NOT_PAD2, Roles.IR_REGISTRATORIUS],
            },
            {
              name: 'adminRequestNew',
              title: 'Naujas prašymas',
              routeRole: [Roles.IR_KAC_DARBUOTOJAS],
            },
            {
              name: 'adminRequestsPreparedSent',
              title: 'Pradiniai prašymai',
              routeRole: [Roles.IR_KAC_DARBUOTOJAS],
            },

          ],
        },
        {
          name: 'journalTab',
          title: 'DOKUMENTAI',
          class: 'menu-list-title',
          children: [
            {
              name: 'checkingJournal',
              title: 'Nepatikrintų dokumentų žurnalas',
              routeRole: [Roles.IR_REGISTRATORIUS],
            },
            {
              name: 'journalReceived',
              title: 'Gautų dokumentų žurnalas',
              routeRole: [Roles.IR_REGISTRATORIUS],
            },
            {
              name: 'journalNotification',
              title: 'Siunčiamų dokumentų žurnalas',
              routeRole: [Roles.IR_REGISTRATORIUS],
            },
            {
              name: 'registryMessages',
              title: 'Registro pranešimai',
              routeRole: [Roles.NOTARAS, Roles.KONSULAS, Roles.TEISMAS, Roles.NOT_PAD, Roles.KAL_VAD, Roles.NOT_PAD2],
            },
          ],
        },
        {
          name: 'errorsCorrectionTab',
          title: 'KLAIDŲ TAISYMAS',
          class: 'menu-list-title',
          children: [
            {
              name: 'errorsCorrectionNew',
              title: 'Naujas klaidų taisymas',
              routeRole: [Roles.IR_REGISTRATORIUS],
            },
            {
              name: 'errorsCorrectionList',
              title: 'Rengiami ir pateikti klaidų taisymai',
              routeRole: [Roles.IR_REGISTRATORIUS],
            },
          ],
        },
        {
          name: 'objectDataChangeTab',
          title: 'OBJEKTŲ DUOMENŲ KITIMO SĄRAŠAS',
          class: 'menu-list-title',
          children: [
            {
              name: 'adminObjectDataChange',
              title: 'Objektų duomenų kitimo sąrašas',
              routeRole: [Roles.IR_REGISTRATORIUS, Roles.NOTARAS, Roles.KONSULAS, Roles.NOT_PAD, Roles.KAL_VAD, Roles.NOT_PAD2], // TODO
            },
          ],
        },
        {
          name: 'searchTab',
          title: 'PAIEŠKOS',
          class: 'menu-list-title',
          children: [
            {
              name: 'searchNew',
              title: 'Paieška',
              routeRole: [Roles.IR_KAC_DARBUOTOJAS, Roles.IR_REGISTRATORIUS, Roles.IR_issami, Roles.IR_issami_su_turiniu, Roles.IR_santrauka, Roles.IR_kitos, Roles.IR_paslauga, Roles.IR_archyvas, Roles.IR_archyvas_kitos, Roles.IR_RC_darbuotojas],
            },
            {
              name: 'searchList',
              title: 'Paieškų sąrašas',
              routeRole: [Roles.IR_KAC_DARBUOTOJAS, Roles.IR_REGISTRATORIUS, Roles.IR_issami, Roles.IR_issami_su_turiniu, Roles.IR_santrauka, Roles.IR_kitos, Roles.IR_paslauga, Roles.IR_archyvas, Roles.IR_archyvas_kitos, Roles.IR_RC_darbuotojas],
            },
            {
              name: 'searchOrders',
              title: 'Išrašų užsakymas',
              routeRole: [Roles.IR_KAC_DARBUOTOJAS, Roles.IR_REGISTRATORIUS],
            },
          ],
        },
        {
          name: 'reportsTab',
          title: 'ATASKAITOS',
          class: 'menu-list-title',
          children: [
            {
              name: 'reports',
              title: 'Ataskaitos formavimas',
              routeRole: [Roles.IR_REGISTRATORIUS],
            },
          ],
        },
        {
          name: 'classifierTab',
          title: 'KLASIFIKATORIAI',
          class: 'menu-list-title',
          children: [
            {
              name: 'classifierServices',
              title: 'Paslaugos ir veiksmai',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'classifierMandateTypes',
              title: 'Įgaliojimo tipai',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            // {
            //   name: 'classifierInstitutions',
            //   title: 'Institucijos',
            // },
            {
              name: 'classifierInstitutionsGroups',
              title: 'Institucijų grupės',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'classifierMandateTermination', // TODO
              title: 'Įgaliojimo pasibaigimo ir pakeitimo pagrindai',
              routeRole: [Roles.IR_ADMINISTRATORIUS], // TODO
            },
            {
              name: 'classifierMandateSuspension', // TODO
              title: 'Įgaliojimo sustabdymo ir sustabdymo panaikinimo pagrindai',
              routeRole: [Roles.IR_ADMINISTRATORIUS], // TODO
            },
            // {
            //   name: 'classifierMandateTermination',
            //   title: 'Įgaliojimo pagrindai',
            // },
            {
              name: 'classifierRejectReasons',
              title: 'Atsisakymo pagrindai',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'classifierEmailAndSMS',
              title: 'El. pašto ir SMS tekstai',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'classifierErrorNotifications',
              title: 'Informaciniai ir klaidų pranešimai',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'classifierSecurityNotifications',
              title: 'Saugos pranešimai',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'ipasasJaPermissions',
              title: 'iPasas teisės (JA)',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'ipasasFaPermissions',
              title: 'iPasas teisės (FA)',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'customCalendar',
              title: 'Šventinių dienų sąrašas',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'nirvarLimit',
              title: 'NIRVAR sritys',
              routeRole: [Roles.IR_REGISTRATORIUS],
            },
            {
              name: 'rcSesLimitation',
              title: 'RC SES apribojimai',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            // {
            //   name: 'classifierTooltips',
            //   title: 'Patartys (angl. tooltips)',
            //   routeRole: [Roles.IR_ADMINISTRATORIUS],
            // },
            // {
            //   name: 'classifierCancelReasons',
            //   title: 'Panaikinimo / atsisakymo požymiai',
            // },
            // {
            //   name: 'classifierCountries',
            //   title: 'Šalys',
            // },
             {
              name: 'classifierAuthorizingPersons',
              title: 'Įgaliojimą tvirtinantys asmenys',
              routeRole: Roles.NOTARINIU_GRUPE, // TODO
            },
          ],
        },
        {
          name: 'adminTab',
          title: 'ADMINISTRAVIMAS',
          class: 'menu-list-title',
          children: [
            {
              name: 'adminSystemBlacklist',
              title: 'Draudžiami paslaugų teikėjai',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'adminSystemNotifications',
              title: 'Sistemos pranešimai',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'adminParameters',
              title: 'Sistemos parametrai',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'adminRecords',
              title: 'Sisteminiai įrašai',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'adminData',
              title: 'Duomenų valdymas',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'JarContainer',
              title: 'JAR duomenų valdymas',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'performedSearches',
              title: 'Įgaliojimų / prokūrų atliktos paieškos',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'adminLogs',
              title: 'Užklausų žurnalas',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'viewData',
              title: 'View duomenys',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'publicJaForms',
              title: 'Viešų JA sąrašas',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'personRules',
              title: 'Asmenų pridėjimo taisyklės',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
            {
              name: 'jarFactIpasRoles',
              title: 'JAR faktas ir iPasas vaidmuo',
              routeRole: [Roles.IR_ADMINISTRATORIUS],
            },
          ],
        },
        {
          name: 'archiveTab',
          title: 'ARCHYVAS',
          class: 'menu-list-title',
          children: [
            {
              name: 'adminObjectArchive',
              title: 'Objektų archyvas',
              routeRole: [Roles.IR_REGISTRATORIUS],
            },
            {
              name: 'adminDestroyedObjectsList',
              title: 'Naikintinų duomenų sąrašas',
              routeRole: [Roles.IR_REGISTRATORIUS],
            },
            {
              name: 'adminDataDestructionActs',
              title: 'Duomenų naikinimo aktai',
              routeRole: [Roles.IR_REGISTRATORIUS],
            },
            {
              name: 'adminStatementArchive',
              title: 'Atliktų paieškų sąrašas',
              routeRole: [Roles.IR_REGISTRATORIUS],
            },
            {
              name: 'adminDataDestructionReports',
              title: 'Paieškų naikinimo ataskaitos',
              routeRole: [Roles.IR_REGISTRATORIUS],
            },
          ],
        },
      ]
    },
    filteredMenuList() {
      return this.menuList
    },
  },
  created() {
    this.$root.$on('drawerToggle', () => {
      this.drawer = !this.drawer
    })
  },

  methods: {
    includesInSubRoutes(parentName){
      switch (parentName) {
        case 'adminMessageNew':
          return [].includes(this.$route.name)
        case 'adminMessagesPreparedSent':
          return ['adminMessageListNew'].includes(this.$route.name)
        case 'errorsCorrectionList':
          return ['errorsCorrectionListNew'].includes(this.$route.name)
        case 'adminRequestNew':
          return [].includes(this.$route.name)
        case 'adminRequestsPreparedSent':
          return ['adminRequestListNew'].includes(this.$route.name)
        case 'checkingJournal':
          return ['journalCheckingForm'].includes(this.$route.name)
        case 'journalReceived':
          return ['adminJournalReceivedForm'].includes(this.$route.name)
        case 'journalNotification':
          return [].includes(this.$route.name)
        case 'registryMessages':
          return [].includes(this.$route.name)
        case 'adminObjectDataChange':
          return ['adminObjectDataChangeForm'].includes(this.$route.name)
        case 'searchNew':
          return [].includes(this.$route.name)
        case 'searchList':
          return ['adminOrderFormList'].includes(this.$route.name) && this.$route.params.list
        case 'searchOrders':
          return ['adminOrderForm'].includes(this.$route.name) && !this.$route.params.list
        case 'classifierServices':
          return ['adminServiceImportForm','adminServiceForm', 'adminParentServiceForm'].includes(this.$route.name)
        case 'classifierMandateTypes':
          return ['adminMandateTypeForm'].includes(this.$route.name)
        case 'classifierInstitutionsGroups':
          return ['adminInstitutionGroupForm'].includes(this.$route.name)
        case 'classifierMandateTermination':
          return ['adminMandateTerminationForm'].includes(this.$route.name)
        case 'classifierMandateSuspension':
          return ['adminMandateSuspensionForm'].includes(this.$route.name)
        case 'classifierRejectReasons':
          return ['adminRejectReasonForm'].includes(this.$route.name)
        case 'classifierEmailAndSMS':
          return ['adminEmailAndSmsForm'].includes(this.$route.name)
        case 'classifierErrorNotifications':
          return ['adminErrorNotificationForm'].includes(this.$route.name)
        case 'classifierSecurityNotifications':
          return ['adminSecurityNotificationForm'].includes(this.$route.name)
        case 'adminSystemBlacklist':
          return [].includes(this.$route.name)
        case 'adminSystemNotifications':
          return ['adminSystemNotificationForm'].includes(this.$route.name)
        case 'adminParameters':
          return [].includes(this.$route.name)
        case 'adminRecords':
          return [].includes(this.$route.name)
        case 'adminData':
        case 'performedSearches':
          return [].includes(this.$route.name)
        case 'itpsi':
          return [].includes(this.$route.name)
        case 'JarContainer':
          return [
            'adminJarFailedJobs',
            'adminLegalentitiesWithoutObj'
          ].includes(this.$route.name)
         case 'adminLogs':
           return [
          'adminLogNirvar',
           'adminLogSaperion',
           'adminLogJarProcuracy',
           'adminLogAsmenys',
           'adminLogPas',
           'adminLogBroker',
           'adminLogApiRequest'].includes(this.$route.name)
         case 'viewData':
           return [
            'viewDataFft',
            'viewDataFate'
           ].includes(this.$route.name)
          case 'rcSesLimitation':
            return [
              'serviceLimitation',
              'serviceLimitationForm',
              'listLimitationForm',
              'serviceLimitation',
              'listLimitation',
              'rcSesLimitation',
            ].includes(this.$route.name)
          case 'personRules':
            return [
              'personRules',
              'objectPersonRules',
              'objectPersonRuleForm',
              'signingPersonRules',
              'signingPersonRuleForm'
            ].includes(this.$route.name)
          case 'jarFactIpasRoles':
            return [
              'jarFactIpasRoles',
            ].includes(this.$route.name)
        default:
          return false
      }

    },
    getClass(item){
      if(item.name == this.$route.name){
        return "v-list-item--active"
      } else if (this.includesInSubRoutes(item.name)){
        return "v-list-item--active"
      }
      return item.class
    },
    goTo(item){
      if(item.name == this.$route.name){
        this.$router.go(0)
      } else {
        this.$router.push({ name: item.name })
      }
    },
    hasRoleGroup(group) {
      let showGroup = []
      if(!group.children){
        return true
      }
      group.children.map((item) => {
        if (this.hasRole(item)) {
          showGroup.push(item)
        }
      })
      return showGroup.length > 0
    },
    hasRole(item) {
      const userRole = this.$store.getters.userRole
      if (!item.routeRole) {
        return true
      }
      return item.routeRole.some((item) => {
        return userRole.includes(item)
      })
    },
    gotoHome() {
      this.$router.push({ name: 'home' })
    },
  },
}
</script>

<style lang="scss">
.top-logo {
  cursor: pointer;
}
.app-drawer {
  overflow: hidden !important;
  &__inner {
    overflow-y: hidden;
  }
  .drawer-menu--scroll {
    overflow: auto;
  }
}
</style>
